module.exports = __webpack_public_path__ + "static/media/magnum_logo.15333455.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/magnum_logo.png
// module id = 703
// module chunks = 0